import { PluginKey } from 'prosemirror-state';

import type { EditorView } from '@lyearn/lygo-core';

import { setPluginMeta } from '../../utils';
import { AddMenuPluginKey } from './consts';
import { blockType } from './types';

export const addAddMenuBlock = (editorView: EditorView, blocks: blockType[]) => {
  if (!editorView.editable) {
    return;
  }

  const state = AddMenuPluginKey.getState(editorView.state);
  if (state?.addMenuBlocks) {
    const newState = { ...state, addMenuBlocks: [...state.addMenuBlocks, ...blocks] };
    setPluginMeta(editorView, AddMenuPluginKey, newState);
  }
};

export const getAddMenuDefaultProps = () => ({
  open: false,
  editorView: null,
  // Position of the cursor.
  offset: [0, 0],
  anchorEl: null,
  placement: document.dir === 'ltr' ? 'top-start' : 'top-end',
  match: '',
});

export const hideAddMenu = (view: EditorView) => {
  const prevProps = AddMenuPluginKey.getState(view.state);
  const props = getAddMenuDefaultProps();

  setPluginMeta(view, AddMenuPluginKey, { ...prevProps, ...props });
};
